export const createSingleAdvert = (payload?: any) => ({
    type: "@saga/CREATE_ADVERT",
    payload
});

